import { CSSProperties } from "react";
import { useNavigate } from "react-router-dom";

import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { Icon } from "#shared/icons/Icon";
import { ROUTES } from "#shared/routes";
import { Button } from "#shared/view/designSystem/Button";

export const BackToClusterButton = ({
  quoteRequestLine,
  style,
  variant,
  ...props
}: {
  quoteRequestLine: QuoteRequestLineDto | undefined | null;
  variant?: "outline" | "filled" | "unstyled";
  style?: CSSProperties;
}) => {
  const navigate = useNavigate();

  if (!quoteRequestLine) {
    return null;
  }

  return (
    <Button
      style={style}
      variant={variant}
      onClick={() => navigate(ROUTES.partnerQuoteRequestLineCluster(quoteRequestLine.id))}
      leftSection={<Icon name="arrowLeft" size={20} />}
      {...props}
    >
      {"Modifier le cluster"}
    </Button>
  );
};
